import SearchIcon from "@mui/icons-material/Search";
import { CircularProgress, InputAdornment, type SxProps, TextField } from "@mui/material";
import type React from "react";

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
  size?: "small" | "medium";
  sx?: SxProps;
  fullWidth?: boolean;
  autoFocus?: boolean;
  loading?: boolean;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  label,
  placeholder = "Search...",
  size = "small",
  sx,
  fullWidth = true,
  autoFocus = false,
  loading = false,
}) => {
  return (
    <TextField
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder ?? label ?? "Search..."}
      label={label}
      size={size}
      sx={sx}
      fullWidth={fullWidth}
      autoFocus={autoFocus}
      variant="outlined"
      InputProps={{
        startAdornment: loading ? (
          <InputAdornment position="start">
            <CircularProgress size={16} color="inherit" style={{ marginRight: 4 }} />
          </InputAdornment>
        ) : (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" color="inherit" />
          </InputAdornment>
        ),
      }}
    />
  );
};
